module.exports = __webpack_public_path__ + "static/media/artist.2f7b2879.webp";